export const de = {
  // Header
  'header.title': 'Go-Sovereign Cloud Connector',
  'header.regulatory': 'Regulatorische Übersicht',
  
  // Intro
  'intro.title': 'Willkommen beim Go-Sovereign Cloud Connector',
  'intro.subtitle': 'Finden Sie den passenden Cloud-Anbieter für Ihre Anforderungen',
  'intro.description': 'Dieser interaktive Fragebogen hilft Ihnen, Cloud-Anbieter basierend auf Ihren spezifischen Anforderungen zu bewerten und zu vergleichen.',
  'intro.start': 'Fragebogen starten',
  'intro.features.title': 'Funktionen',
  'intro.features.questionnaire': 'Interaktiver Fragebogen',
  'intro.features.comparison': 'Anbietervergleich',
  'intro.features.visualization': 'Visualisierungen',
  'intro.features.export': 'PDF-Export',
  
  // Questionnaire
  'questionnaire.close': 'Beenden',
  'questionnaire.back': 'Zurück',
  'questionnaire.next': 'Weiter',
  'questionnaire.skip': 'Überspringen',
  'questionnaire.progress': 'Frage {current} von {total}',
  'questionnaire.category': 'Kategorie',
  
  // Provider Selection
  'providers.title': 'Welche Anbieter möchten Sie vergleichen?',
  'providers.subtitle': 'Wählen Sie mindestens einen Cloud-Anbieter aus',
  'providers.select': 'Anbieter auswählen',
  'providers.proceed': 'Weiter',
  'providers.selectAtLeastOne': 'Bitte wählen Sie mindestens einen Anbieter aus',
  
  // IT Landscape
  'itLandscape.title': 'Wie sieht Ihre aktuelle IT-Landschaft aus?',
  'itLandscape.subtitle': 'Bitte wählen Sie eine Option aus',
  'itLandscape.onprem': 'On-Premise',
  'itLandscape.private': 'Private Cloud',
  'itLandscape.hybrid': 'Hybrid Cloud',
  'itLandscape.public': 'Public Cloud',
  
  // Cloud Usage
  'cloudUsage.title': 'Welche Cloud-Anbieter nutzen Sie aktuell?',
  'cloudUsage.subtitle': 'Mehrfachauswahl möglich',
  'cloudUsage.none': 'Keine',
  'cloudUsage.other': 'Andere',
  
  // Questions
  'questions.weight': 'Gewichtung',
  'questions.importance.low': 'gering',
  'questions.importance.medium': 'mittel',
  'questions.importance.high': 'sehr wichtig',
  'questions.info': 'Mehr Infos',
  'questions.howImportant': 'Wie wichtig ist Ihnen dieses Kriterium?',
  
  // Results
  'results.title': 'Ihre Ergebnisse',
  'results.subtitle': 'Basierend auf Ihren Antworten',
  'results.ranking': 'Ranking',
  'results.score': 'Gesamtscore',
  'results.export': 'PDF exportieren',
  'results.restart': 'Neu starten',
  'results.topProvider': 'Top-Empfehlung',
  'results.showDetails': 'Details anzeigen',
  'results.hideDetails': 'Details ausblenden',
  
  // Views
  'view.bars': 'Balkendiagramm',
  'view.radar': 'Radardiagramm',
  'view.heatmap': 'Heatmap',
  'view.switch': 'Ansicht wechseln',
  
  // Categories
  'category.Technical': 'Technisch',
  'category.Regulatory': 'Regulatorisch',
  'category.Business': 'Business',
  
  // Weights
  'weight.adjust': 'Gewichtung anpassen',
  'weight.reset': 'Zurücksetzen',
  'weight.category': 'Kategorie-Gewichtung',
  
  // Common
  'common.loading': 'Lädt...',
  'common.error': 'Fehler',
  'common.close': 'Schließen',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.confirm': 'Bestätigen',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.ok': 'OK',
  
  // Errors
  'error.loadData': 'Fehler beim Laden der Daten',
  'error.noProviders': 'Keine Anbieter verfügbar',
  'error.noMetrics': 'Keine Metriken verfügbar',
  'error.exportPdf': 'Fehler beim Exportieren des PDFs',
  
  // Language
  'language.switch': 'Sprache wechseln',
  'language.switchTo.en': 'Switch to English',
  'language.switchTo.de': 'Zu Deutsch wechseln',

  // Email Modal
  'modal.title': 'Report per E-Mail erhalten',
  'modal.reportNameLabel': 'Report-Name (optional)',
  'modal.reportNamePlaceholder': 'z.B. Cloud-Bewertung Q2 2026',
  'modal.emailLabel': 'E-Mail-Adresse',
  'modal.emailPlaceholder': 'ihre@email.de',
  'modal.emailError': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'modal.consent': 'Ich stimme zu, dass meine E-Mail-Adresse zum Versand des Reports und zur möglichen Kontaktaufnahme gespeichert wird. Ich kann meine Einwilligung jederzeit widerrufen.',
  'modal.privacyLink': 'Datenschutzerklärung',
  'modal.privacyNotice': 'Ihre E-Mail-Adresse wird ausschließlich zum Versand des Reports und zur möglichen Kontaktaufnahme durch den Betreiber verwendet (Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO). Die Daten werden nach 180 Tagen automatisch gelöscht. Sie können Ihre Einwilligung jederzeit per E-Mail an david@schneider4me.de widerrufen.',
  'modal.submit': 'Report senden',
  'modal.loading': 'Report wird erstellt und versendet...',
  'modal.success': 'Ihr Report wurde erfolgreich versendet!',
  'modal.successDetail': 'Der Report wurde an {email} gesendet.',
  'modal.error': 'Beim Versand ist ein Fehler aufgetreten.',
  'modal.retry': 'Erneut versuchen',
  'modal.close': 'Schließen',

  // Privacy Policy
  'privacy.title': 'Datenschutzerklärung',
  'privacy.back': 'Zurück zur Startseite',

  // Cloud Act
  'cloudAct.title': 'Ist es für Sie relevant, dass Ihr Cloud-Anbieter nicht dem US Cloud Act unterliegt?',
  'cloudAct.yes': 'Ja, das ist mir wichtig',
  'cloudAct.no': 'Nein, das ist nicht relevant',
  'cloudAct.proceed': 'Weiter',

  // Sidebar
  'sidebar.questionnaire': 'Fragebogen starten',
  'sidebar.reset': 'Zurücksetzen',
  'sidebar.exportReport': 'Report exportieren',
  'sidebar.regulatory': 'Regulatorik Übersicht',
  'sidebar.close': 'Menü schließen',
  'sidebar.openMenu': 'Menü öffnen',
  'sidebar.closeMenu': 'Menü schließen',
  'sidebar.backToModeSelector': 'Zurück zur Modusauswahl',
  'sidebar.sealFramework': 'SEAL Framework',
  'sidebar.switchToCloud': 'Cloud-Vergleich',
  'sidebar.switchToWorkplace': 'Arbeitsplatz-Vergleich',

  // Comparison Mode Selector
  'modeSelector.title': 'Wählen Sie Ihren Vergleichsmodus',
  'modeSelector.cloud.title': 'Cloud Lösungen',
  'modeSelector.cloud.description': 'Vergleichen Sie Cloud-Anbieter hinsichtlich Souveränität, Compliance und technischer Eignung.',
  'modeSelector.cloud.cta': 'Cloud-Vergleich starten',
  'modeSelector.workplace.title': 'Arbeitsplatzlösungen',
  'modeSelector.workplace.description': 'Bewerten Sie die digitale Souveränität Ihrer Arbeitsplatzlösungen mit dem SEAL-Framework.',
  'modeSelector.workplace.cta': 'Workplace-Vergleich starten',

  // Workplace Provider Selection
  'workplace.providerSelection.title': 'Provider auswählen',
  'workplace.providerSelection.hint': 'Mindestens 2 Provider auswählen',
  'workplace.providerSelection.selectAll': 'Alle auswählen',
  'workplace.providerSelection.deselectAll': 'Alle abwählen',
  'workplace.providerSelection.continue': 'Weiter',
  'workplace.providerSelection.selected': '{count} ausgewählt',

  // Provider Groups
  'workplace.group.productivityOffice': 'Produktivität & Office',
  'workplace.group.communicationCollaboration': 'Kommunikation & Kollaboration',
  'workplace.group.knowledgeManagement': 'Wissensmanagement',
  'workplace.group.identityAccess': 'Identität & Zugriff',
  'workplace.group.operatingSystems': 'Betriebssysteme',
  'workplace.group.cloudInfrastructure': 'Cloud & Infrastruktur',
  'workplace.group.endpointDeviceManagement': 'Endpoint & Device Management',
  'workplace.group.securityCompliance': 'Security & Compliance',
  'workplace.group.monitoringObservability': 'Monitoring & Observability',

  // Workplace Questionnaire
  'workplace.questionnaire.title': 'Feature Group Bewertung',
  'workplace.questionnaire.rateRelevance': 'Wie relevant ist diese Feature Group?',
  'workplace.questionnaire.notRelevant': 'Nicht relevant',
  'workplace.questionnaire.lowRelevance': 'Wenig relevant',
  'workplace.questionnaire.relevant': 'Relevant',
  'workplace.questionnaire.highRelevance': 'Sehr relevant',
  'workplace.questionnaire.features': 'Features in dieser Gruppe',
  'workplace.questionnaire.continue': 'Weiter zum Solution Builder',

  // Solution Builder
  'workplace.solutionBuilder.title': 'Solution Builder',
  'workplace.solutionBuilder.sealScore': 'SEAL Score',
  'workplace.solutionBuilder.unassigned': 'Nicht zugewiesen',
  'workplace.solutionBuilder.selectProvider': 'Provider wählen',
  'workplace.solutionBuilder.solutionScore': 'Gesamt-SEAL-Score',
  'workplace.solutionBuilder.incomplete': 'Score unvollständig',
  'workplace.solutionBuilder.continue': 'Ergebnisse anzeigen',
  'workplace.solutionBuilder.showFeatures': 'Features anzeigen',
  'workplace.solutionBuilder.hideFeatures': 'Features ausblenden',

  // Feature Ratings
  'workplace.rating.included': 'Enthalten',
  'workplace.rating.addon': 'Addon nötig',
  'workplace.rating.notIncluded': 'Nicht enthalten',

  // SEAL
  'workplace.seal.level': 'SEAL Level {level}',
  'workplace.seal.framework': 'SEAL Framework Referenz',
  'workplace.seal.justification': 'Begründung',

  // Workplace Results
  'workplace.results.title': 'Ihre Workplace-Lösung',
  'workplace.results.sealLevel': 'SEAL Level',
  'workplace.results.breakdown': 'Aufschlüsselung',
  'workplace.results.generateReport': 'Report generieren',
  'workplace.results.reset': 'Zurücksetzen',
  'workplace.results.backToBuilder': 'Zurück zum Solution Builder',

  // Workplace Steps
  'workplace.steps.providerSelection': 'Provider',
  'workplace.steps.questionnaire': 'Bewertung',
  'workplace.steps.solutionBuilder': 'Solution Builder',
  'workplace.steps.results': 'Ergebnisse',

  // Saved State
  'workplace.savedState.continue': 'Fortfahren wo Sie aufgehört haben',
  'workplace.savedState.startNew': 'Neu beginnen',

  // Workplace SOV Flow - Step labels
  'workplace.steps.infrastructure': 'Infrastruktur',
  'workplace.steps.istZustand': 'Ist-Zustand',
  'workplace.steps.istScore': 'Ist-Score',
  'workplace.steps.sovWeights': 'Gewichtung',

  // Step 1: Infrastructure
  'workplace.infrastructure.title': 'Wie betreiben Sie Ihre Arbeitsplatz-Software?',
  'workplace.infrastructure.onPremise': 'Alles On-Premise / Self-hosted',
  'workplace.infrastructure.cloud': 'Alles bei einem Cloud-Anbieter',
  'workplace.infrastructure.saas': 'Alles SaaS (Provider-hosted)',
  'workplace.infrastructure.hybrid': 'Hybrid / Mixed (verschiedene Modelle pro Tool)',
  'workplace.infrastructure.cloudFollowUp': 'Welchen Cloud-Anbieter nutzen Sie?',
  'workplace.infrastructure.continue': 'Weiter',

  // Step 2: Ist-Zustand
  'workplace.istZustand.title': 'Ist-Zustand erfassen',
  'workplace.istZustand.description': 'Geben Sie für jede Feature Group an, welches Tool Sie aktuell nutzen.',
  'workplace.istZustand.selectProvider': 'Provider auswählen',
  'workplace.istZustand.selectDeployment': 'Deployment-Modell wählen',
  'workplace.istZustand.unassigned': 'Nicht zugewiesen',
  'workplace.istZustand.progress': '{count} von {total} zugewiesen',
  'workplace.istZustand.continue': 'Weiter',
  'workplace.istZustand.back': 'Zurück',

  // Step 3: Ist-Score
  'workplace.istScore.title': 'Ihr aktueller Sovereignty Score',
  'workplace.istScore.breakdown': 'Aufschlüsselung nach Feature Group',
  'workplace.istScore.objectives': 'SOV-Objectives Übersicht',
  'workplace.istScore.noScore': 'Kein Score verfügbar',
  'workplace.istScore.sealLevel': 'SEAL Level',
  'workplace.istScore.continue': 'Weiter',
  'workplace.istScore.back': 'Zurück',

  // Step 4: SOV Weights
  'workplace.sovWeights.title': 'SOV-Objectives Gewichtung',
  'workplace.sovWeights.description': 'Passen Sie die Gewichtung der 8 SOV-Objectives an Ihre Prioritäten an.',
  'workplace.sovWeights.resetDefaults': 'Auf Standard zurücksetzen',
  'workplace.sovWeights.total': 'Gesamt',
  'workplace.sovWeights.remaining': 'Verbleibend: {value}%',
  'workplace.sovWeights.skip': 'Mit Standard-Gewichtung fortfahren',
  'workplace.sovWeights.validationError': 'Die Summe der Gewichtungen muss 100% ergeben.',
  'workplace.sovWeights.continue': 'Weiter',
  'workplace.sovWeights.back': 'Zurück',

  // Step 5: Solution Builder (new keys)
  'workplace.solutionBuilder.description': 'Stellen Sie Ihre souveräne Ziel-Konfiguration zusammen. Provider sind nach SOV-Score sortiert.',
  'workplace.solutionBuilder.zielScore': 'Ziel-Score',
  'workplace.solutionBuilder.istScore': 'Ist-Score',
  'workplace.solutionBuilder.sovScore': 'SOV-Score',
  'workplace.solutionBuilder.deploymentModel': 'Deployment',
  'workplace.solutionBuilder.currentIst': 'Ist',
  'workplace.solutionBuilder.back': 'Zurück',

  // Step 6: Results (new keys)
  'workplace.results.istScore': 'Ist-Score',
  'workplace.results.zielScore': 'Ziel-Score',
  'workplace.results.delta': 'Veränderung',
  'workplace.results.comparison': 'Vorher / Nachher Vergleich',
  'workplace.results.perObjective': 'SOV-Objectives Vergleich',
  'workplace.results.perFeatureGroup': 'Feature Group Vergleich',

  // Deployment labels
  'workplace.deployment.saas': 'SaaS (Provider-hosted)',
  'workplace.deployment.managedEu': 'Managed EU (EU-Hoster)',
  'workplace.deployment.hostedEu': 'Hosted: EU-Anbieter',
  'workplace.deployment.hostedNonEu': 'Hosted: Non-EU-Anbieter',
  'workplace.deployment.selfHosted': 'Self-hosted (On-Premise)',

  // SOV Objective names
  'workplace.sov.sov1': 'Strategische Souveränität',
  'workplace.sov.sov2': 'Rechtliche & Jurisdiktionelle Souveränität',
  'workplace.sov.sov3': 'Daten- & KI-Souveränität',
  'workplace.sov.sov4': 'Operationelle Souveränität',
  'workplace.sov.sov5': 'Lieferketten-Souveränität',
  'workplace.sov.sov6': 'Technologische Souveränität',
  'workplace.sov.sov7': 'Sicherheits- & Compliance-Souveränität',
  'workplace.sov.sov8': 'Ökologische Nachhaltigkeit',

  // Other Provider
  'workplace.other.label': 'Anderer Anbieter',
  'workplace.other.selectCategory': 'Kategorie wählen',
  'workplace.other.openSource': 'Open Source',
  'workplace.other.euProvider': 'EU-Anbieter',
  'workplace.other.nonEuProvider': 'Nicht-EU-Anbieter',
  'workplace.other.euOpenSource': 'EU Open Source',
  'workplace.other.nonEuOpenSource': 'Non-EU Open Source',
  'workplace.other.euProviderProprietary': 'EU-Anbieter (Proprietär)',
  'workplace.other.nonEuProviderProprietary': 'Non-EU-Anbieter (Proprietär)',
  'workplace.other.divider': '── Sonstige ──',

  // Saved state (SOV flow)
  'workplace.sovState.continue': 'Fortsetzen',
  'workplace.sovState.startNew': 'Neu beginnen',
  'workplace.sovState.prompt': 'Sie haben einen gespeicherten Fortschritt. Möchten Sie fortfahren?',

  // Sovereignty Scoring (Cloud Comparison)
  'sovereignty.score': 'Sovereignty Score',
  'sovereignty.businessScore': 'Business Score',
  'sovereignty.domainScores': 'Domänen-Scores',
  'sovereignty.sealLevel': 'SEAL-Level',
  'sovereignty.details': 'Sovereignty Scoring Details',
  'sovereignty.recommendation': 'Empfehlung',
  'sovereignty.recommendationText': 'Basierend auf Ihren Gewichtungen empfehlen wir: ',
  'sovereignty.scoreOf': 'mit einem Score von ',
  'sovereignty.selectProfile': 'Profil wählen',
  'sovereignty.cloudActDisqualified': 'Cloud Act disqualifiziert',
  'sovereignty.c5Prerequisite': 'C5 Voraussetzung',
  'sovereignty.outsideBsiScope': 'Außerhalb BSI-Verantwortung',
  'sovereignty.downloadC3A': 'C3A Framework herunterladen',
  'sovereignty.radarHint': 'Radar zeigt die 8 SOV-Domänen (SOV-1 bis SOV-8) als Achsen mit den Top-3-Anbietern.',
  'sovereignty.heatmapHint': 'Scores je Merkmal (0–10) gruppiert nach SOV-Domäne. Sattere Farbe = höherer Score.',
  'sovereignty.metric': 'Merkmal',
  'sovereignty.avgDomainScore': 'Ø Domänen-Score',
  'sovereignty.businessGroup': 'Business',
  'sovereignty.frameworkMode': 'Bewertungsmodus',
  'sovereignty.hardRequirementFailed': 'Mindestanforderung nicht erfüllt',
  'sovereignty.securityFilterFailed': 'Security-Mindestanforderung nicht erfüllt (SOV-7 < 7)',
  'sovereignty.excluded': 'Ausgeschlossen',
} as const;

export type TranslationKey = keyof typeof de;
